import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, Facebook, Instagram, Youtube, Twitter, LogIn, ShieldAlert } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-jpa-ink text-white mt-20 relative overflow-hidden">
      <div className="absolute inset-0 grain pointer-events-none opacity-20" />
      <div className="max-w-[1400px] mx-auto px-4 md:px-8 py-16 grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-10 relative">

        {/* Logo column */}
        <div className="col-span-2 md:col-span-2 lg:col-span-2">
          <img
            src="/logos/jpa-logo.png"
            alt="Jharkhand Pickleball Association"
            data-testid="footer-jpa-logo"
            className="h-24 md:h-28 w-auto object-contain bg-white p-2 rounded-sm"
          />
          <p className="text-sm text-white/70 leading-relaxed mt-5 max-w-xs">
            The official state governing body for pickleball in Jharkhand. Affiliated with the All India Pickleball Association (AIPA).
          </p>
          <div className="flex gap-3 mt-6">
            {[Facebook, Instagram, Youtube, Twitter].map((Icon, i) => (
              <a key={i} href="#" data-testid={`social-link-${i}`} className="w-9 h-9 grid place-items-center border border-white/20 hover:bg-jpa-primary hover:border-jpa-primary transition-colors rounded-sm">
                <Icon className="w-4 h-4" />
              </a>
            ))}
          </div>
        </div>

        {/* Players */}
        <div>
          <h4 className="font-display text-xl tracking-wider mb-4 text-jpa-accent">Players</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/players" data-testid="footer-players-directory" className="text-white/70 hover:text-jpa-accent transition-colors">Directory</Link></li>
            <li><Link to="/rankings" data-testid="footer-players-rankings" className="text-white/70 hover:text-jpa-accent transition-colors">Rankings</Link></li>
          </ul>
        </div>

        {/* JPA */}
        <div>
          <h4 className="font-display text-xl tracking-wider mb-4 text-jpa-accent">JPA</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/about" data-testid="footer-about" className="text-white/70 hover:text-jpa-accent transition-colors">About JPA</Link></li>
            <li><Link to="/contact" data-testid="footer-contact" className="text-white/70 hover:text-jpa-accent transition-colors">Contact us</Link></li>
            <li><Link to="/about?tab=team" data-testid="footer-team" className="text-white/70 hover:text-jpa-accent transition-colors">Team</Link></li>
          </ul>
        </div>

        {/* Logins */}
        <div>
          <h4 className="font-display text-xl tracking-wider mb-4 text-jpa-accent">Logins</h4>
          <ul className="space-y-2 text-sm">
            <li>
              <Link to="/login" data-testid="footer-organiser-login" className="text-white/70 hover:text-jpa-accent transition-colors inline-flex items-center gap-2">
                <LogIn className="w-3.5 h-3.5" /> Organiser login
              </Link>
            </li>
            <li>
              <Link to="/referee/login" data-testid="footer-referee-login" className="text-white/70 hover:text-jpa-accent transition-colors inline-flex items-center gap-2">
                <ShieldAlert className="w-3.5 h-3.5" /> Referee login
              </Link>
            </li>
          </ul>
        </div>

        {/* Contact + Legal */}
        <div className="col-span-2 md:col-span-2 lg:col-span-1">
          <h4 className="font-display text-xl tracking-wider mb-4 text-jpa-accent">Contact</h4>
          <ul className="space-y-3 text-sm">
            <li className="flex items-start gap-2"><MapPin className="w-4 h-4 mt-0.5 text-jpa-accent flex-shrink-0" /> 3-S Sadan Geeta Colony, Latma Road, Singh More, Post- Hatia, P.s- Jaganathpur Ranchi, Jharkhand 834003</li>
            <li className="flex items-center gap-2"><Phone className="w-4 h-4 text-jpa-accent" /> +91 93047 57995</li>
            <li className="flex items-center gap-2"><Mail className="w-4 h-4 text-jpa-accent" /> info@jpaofficial.com</li>
          </ul>

          <h4 className="font-display text-xl tracking-wider mb-3 mt-6 text-jpa-accent">Legal</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/terms" data-testid="footer-terms" className="text-white/70 hover:text-jpa-accent transition-colors">Terms &amp; Conditions</Link></li>
            <li><Link to="/privacy" data-testid="footer-privacy" className="text-white/70 hover:text-jpa-accent transition-colors">Privacy Policy</Link></li>
            <li><Link to="/refund-policy" data-testid="footer-refund" className="text-white/70 hover:text-jpa-accent transition-colors">Refund &amp; Cancellation Policy</Link></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-[1400px] mx-auto px-4 md:px-8 py-5 flex flex-col md:flex-row justify-between items-center gap-2 text-xs text-white/60">
          <span>© {new Date().getFullYear()} Jharkhand Pickleball Association. All rights reserved.</span>
          <span className="tracking-widest uppercase">Play. Compete. Belong.</span>
        </div>
      </div>
    </footer>
  );
}
